import { PageContainer } from '@/components/page/PageContainer';
import { PageSizer, SizerMode } from '@/components/page/PageSizer';
import { Button } from '@/components/shared/button/Button';
import { TSTitleCard } from '@/components/shared/card/Card';
import { Feature } from '@/services/backstage/Feature';
import { useGetMeQuery } from '@/services/gql/graphql.generated';
import { useScheduleRequestStatus } from '@/services/workingPatterns/useScheduleRequestStatus';
import { FunctionComponent } from 'react';
import { FiBell } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { MyScheduleGroupedScheduleChangeRequestDetailCard } from './MyScheduleGroupedRequestDetailCard';

const MyScheduleChangeRequestsPage: FunctionComponent = () => {
  const [{ data: meData }] = useGetMeQuery();
  const employeeId = meData?.myEmployee?.identityId;
  const navigate = useNavigate();

  const { upcomingApprovedRequests } = useScheduleRequestStatus(employeeId);

  return (
    <Feature name="requests">
      <PageContainer>
        <PageSizer mode={SizerMode.PAGE} className="justify-items-center">
          <TSTitleCard className="w-full space-y-5 p-5" title="Upcoming Schedule Changes" icon={FiBell}>
            {upcomingApprovedRequests.length === 0 ? (
              <p className="text-gray-400">No upcoming approved schedule changes.</p>
            ) : (
              <MyScheduleGroupedScheduleChangeRequestDetailCard
                requests={upcomingApprovedRequests}
              />
            )}
            <div className="flex justify-end">
              <Button big onClick={() => navigate(-1)}>
                Back
              </Button>
            </div>
          </TSTitleCard>
        </PageSizer>
      </PageContainer>
    </Feature>
  );
};

export default MyScheduleChangeRequestsPage;
